/**
 * Created by Nisarg on 7/18/2017.
 */
import React, {Component} from 'react';
import firebase from 'firebase';
import $ from 'jquery';

export default class AllCategories extends Component {
    constructor() {
        super();

        this.state = {allCategories: []};
    }

    componentDidMount() {
        const _this = this;
        let categoryRef = firebase.database().ref("CategoryDetails");
        categoryRef.on('value', ((response) => {
            let allCategories = response.val();
            if (allCategories) {
                const keys = Object.keys(allCategories);
                allCategories = keys.map((key) => {
                    return allCategories[key]
                });
                _this.setState({allCategories});
            }
        }))
    }

    goToCategory(e) {
        const id = e.currentTarget.attributes["data-id"].value;
        this.props.history.push("/categories/addcategory/" + id);
    }

    renderCategories(category) {
        return (
            <div className="col-sm-6 col-md-6" key={category.id} data-id={category.id} style={{cursor:'pointer'}}
                 onClick={this.goToCategory.bind(this)}>
                <div className="card card-outline-primary">
                    <div className="card-header">
                        {category.name}
                    </div>
                    {/*
                     <div className="card-block">
                     <div className="imgcard-group mb-0">
                     <div className="imgcard imgcard-cascade wider">
                     <div>
                     <img src={category.url}
                     alt="Category" className="img-fluid"
                     />
                     </div>
                     </div>
                     </div>
                     </div>
                     */}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">

                    {this.state.allCategories.length > 0 ? this.state.allCategories.map((category) => {
                        return this.renderCategories(category)
                    }) : "Nisarg"}

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/IslandManagement/AllCategories/AllCategories.js